import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import CloseModalButton from "src/assets/icon/close/CloseModalButton";
import useLocales from "src/hooks/useLocales";

interface IGenerateDocSeriesDialogProps {
  isShowModal: boolean;
  showModalMethod: (isVisible: boolean) => void;
  documentNumber: string;
  onRegenerateClick: VoidFunction;
  isLoading?: boolean;
}

const GenerateDocSeriesDialog: React.FC<IGenerateDocSeriesDialogProps> = (
  props,
) => {
  const {
    isShowModal,
    showModalMethod,
    documentNumber,
    onRegenerateClick,
    isLoading = false,
  } = props;
  const { translate } = useLocales("manual_document_screen");

  return (
    <Dialog
      open={isShowModal}
      onClose={() => showModalMethod(false)}
      fullWidth
      maxWidth={"sm"}
      scroll="body"
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}
      >
        <Typography id="modal-modal-title" variant="h5">
          {translate("document_number_already_exists")}
        </Typography>
        <IconButton
          sx={{ height: 30, width: 30 }}
          onClick={() => showModalMethod(false)}
        >
          <CloseModalButton />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", pt: 1 }}
            align="center"
          >
            {translate("document_number_exists_message", {
              documentNumber: documentNumber,
            })}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "text.primary", fontWeight: "bold" }}
            align="center"
          >
            {translate("would_you_like_to_generate_new_document_number")}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "center",
            mt: 1,
          }}
        >
          <Button
            onClick={() => showModalMethod(false)}
            size="small"
            variant="outlined"
            disabled={isLoading}
          >
            {translate("cancel_button")}
          </Button>

          <LoadingButton
            type="submit"
            variant="contained"
            loading={isLoading}
            onClick={onRegenerateClick}
            loadingPosition="start"
            sx={{ ml: 1 }}
            size="small"
          >
            {translate("regenerate_document_number")}
          </LoadingButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default GenerateDocSeriesDialog;
